import hash from 'object-hash'
import { RequestCache } from './RequestCache'
import { RequestCacheOptions } from '../../Types/Types'
import { EMPTY_STRING } from '../../../constants/Common'
import { isVarNotEmpty } from '../../../utils/GlobalFunctions'

/**
 * This holds and list of the current caches stored by URL and allows you to access them.
 */
export class RequestCacheHandler {
    private caches: { [key: string]: RequestCache } = {}

    /**
     * Get a cache by URL.
     *
     * @param url - The URL to get the cache for.
     * @param body - The body of the request to get the cache for, if applicable.
     * @param options - The options for the cache.
     * @returns - The RequestCache object for the given URL.
     */
    public cacheByURL(url: string, body?: unknown, options?: RequestCacheOptions): RequestCache {
        const bodyHash: string = isVarNotEmpty(body) ? hash(body) : EMPTY_STRING
        const cacheKey: string = `${url}${bodyHash ? `::${bodyHash}` : EMPTY_STRING}`

        let cache: RequestCache = this.caches[cacheKey]

        if (!cache) {
            cache = RequestCache.newInstance(options)
            this.caches[cacheKey] = cache
        }

        return cache
    }

    /**
     * Purges a cache entry by URL.
     *
     * @param url - The URL to purge the cache for.
     */
    public purgeCacheForURL(url: string): void {
        delete this.caches[url]
    }
}
